import React from 'react';

const Closed = (props) => {
  const { ClosedMessage } = props.QuestionData.Form;
  return (
    <div className="c-create-question" data-cy="ui-isclosed">
      {ClosedMessage && (
        <div dangerouslySetInnerHTML={{ __html: ClosedMessage }}></div>
      )}
    </div>
  );
};

export default Closed;
